module.exports = __webpack_public_path__ + "static/media/GLVid.0a2f199f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Components/App/Media/GLVid.mp4
// module id = 199
// module chunks = 0